import { createAction, props } from '@ngrx/store';

import { BankAccountsResponse } from './bank-accounts.types';

export const bankAccountsFetchListStart = createAction('BANK_ACCOUNTS/FETCH_LIST_START');
export const bankAccountsFetchListSuccess = createAction(
  'BANK_ACCOUNTS/FETCH_LIST_SUCCESS',
  props<{ payload: BankAccountsResponse }>(),
);
export const bankAccountsFetchListFail = createAction('BANK_ACCOUNTS/FETCH_LIST_FAIL');

export const bankAccountsResetList = createAction('BANK_ACCOUNTS/RESET_LIST');
